import { render } from "./HeaderHero.vue?vue&type=template&id=5abcb586"
import script from "./HeaderHero.vue?vue&type=script&lang=js"
export * from "./HeaderHero.vue?vue&type=script&lang=js"
script.render = render

export default script